import React from "react";
import { useFieldArray } from "react-hook-form";
import InfoFields from "../infoFields/InfoFields";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "./Details.css";
import SpecsheetButtonWhite from "../../button/specsheetButtonWhite/SpecsheetButtonWhite";

const Details = ({
  control,
  register,
  index,
  showSidebarGenericSpecsheetInformation,
}) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `creatives[${index}].details`,
  });

  return (
    <div className="form-wrapper">
      <ul>
        {fields.map((item, indexDetails) => {
          return (
            <li key={item.id}>
              <div className="input-container">
                <div className="inner-input-generic-details-form-container">
                  <h3>Generic Details</h3>

                  <InputFieldFormArray
                    label="Title"
                    placeholder="Video File (optional asset) / Creative Assets / etc"
                    fieldRef={register(
                      `creatives[${index}].details[${indexDetails}].title`,
                      {
                        required: false,
                      }
                    )}
                    name={`creatives[${index}].details[${indexDetails}].title`}
                    key={item.id}
                  />

                  <InfoFields
                    {...{
                      control,
                      register,
                      index,
                      indexDetails,
                    }}
                  />
                  <div className="delete-button-wrapper">
                    <button
                      className="details-button delete-button"
                      type="button"
                      onClick={() => {
                        remove(indexDetails);
                      }}
                    >
                      Delete <br /> Generic Details
                    </button>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        className="append-button"
        onClick={() =>
          append({
            title: "",
            infoFields: [
              {
                subject: "",
                text: "",
                type: "text",
                url: "",
              },
            ],
          })
        }
      >
        Add <br /> Generic Details
      </button>

      <section className="done-section">
        <SpecsheetButtonWhite
          type="button"
          handleClick={showSidebarGenericSpecsheetInformation}
        >
          Done
        </SpecsheetButtonWhite>
      </section>
    </div>
  );
};

export default Details;
